module.exports = __webpack_public_path__ + "static/media/MFA-Background-003.fd0c03f0.png";